import { ITariff } from '../../http/models/models';
import CommonService from '../../http/services/CommonService';
import { createFetchingEntity } from '../../utils/effector/creatFetchingEntity';

export const $tariffs = createFetchingEntity<ITariff[]>({
	requestHandler: async () => (await CommonService.getTariffs()).data,
	doneDataHandler: (state, payload) => payload,
	useCache: true,
});
